<p-toast position="top-right"></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="page-wrapper">

  <!-- ─── En-tête ─────────────────────────────────── -->
  <div class="page-header">
    <div class="page-title">
      <div class="title-icon"><i class="pi pi-users"></i></div>
      <div>
        <h2>Contacts</h2>
        <span class="count-badge">{{ filteredContacts.length }} affiché(s) · {{ totalCount }} au total</span>
      </div>
    </div>
    <div class="header-actions">
      <button pButton type="button"
        [icon]="showFilters ? 'pi pi-filter-slash' : 'pi pi-filter'"
        [label]="showFilters ? 'Masquer filtres' : 'Filtres'"
        class="p-button-outlined p-button-sm"
        (click)="showFilters = !showFilters">
      </button>
      <button pButton type="button" icon="pi pi-refresh" label="Rafraîchir"
        class="p-button-outlined p-button-sm" (click)="load()">
      </button>
      <button pButton type="button" icon="pi pi-plus" label="Nouveau contact"
        class="p-button-sm btn-create" (click)="openCreate()">
      </button>
    </div>
  </div>

  <!-- ─── Panneau filtres ──────────────────────────── -->
  <div class="filter-panel" *ngIf="showFilters">
    <div class="search-wrap">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input type="text" pInputText placeholder="Nom, email, mobile…"
          [(ngModel)]="search" (keyup.enter)="onSearch()" style="width:240px" />
      </span>
      <button pButton type="button" icon="pi pi-search" class="p-button-sm" (click)="onSearch()"></button>
    </div>

    <div class="filter-sep"></div>

    <div class="filter-group">
      <label>Statut lead</label>
      <p-dropdown [options]="statutLeadFilterOptions" [(ngModel)]="filterStatut"
        optionLabel="label" optionValue="value"
        [style]="{ minWidth:'175px' }" appendTo="body">
      </p-dropdown>
    </div>

    <div class="filter-group">
      <label>Type contact</label>
      <p-dropdown [options]="typeContactFilterOptions" [(ngModel)]="filterType"
        optionLabel="label" optionValue="value"
        [style]="{ minWidth:'165px' }" appendTo="body">
      </p-dropdown>
    </div>

    <div class="filter-group">
      <label>Cycle de vie</label>
      <p-dropdown [options]="cycleDeVieFilterOptions" [(ngModel)]="filterCycle"
        optionLabel="label" optionValue="value"
        [style]="{ minWidth:'150px' }" appendTo="body">
      </p-dropdown>
    </div>

    <div class="filter-group">
      <label>Origine</label>
      <p-dropdown [options]="origineFilterOptions" [(ngModel)]="filterOrigine"
        optionLabel="label" optionValue="value"
        [showClear]="true" placeholder="Toutes"
        (onChange)="load()"
        [style]="{ minWidth:'160px' }" appendTo="body">
      </p-dropdown>
    </div>

    <div class="filter-group">
      <label>Email</label>
      <p-dropdown [options]="emailValidityOptions" [(ngModel)]="filterEmailValidity"
        optionLabel="label" optionValue="value"
        [showClear]="true" placeholder="Tous"
        (onChange)="load()"
        [style]="{ minWidth:'150px' }" appendTo="body">
      </p-dropdown>
    </div>

    <div class="filter-group" *ngIf="isAdmin">
      <label>Conseiller</label>
      <p-dropdown [options]="usersFilter" [(ngModel)]="filterUserId"
        optionLabel="label" optionValue="value"
        [filter]="true" filterBy="label"
        [showClear]="true" placeholder="Tous"
        (onChange)="load()"
        [style]="{ minWidth:'160px' }" appendTo="body">
      </p-dropdown>
    </div>

    <div class="filter-group">
      <label>Période de création</label>
      <p-calendar [(ngModel)]="dateRange" selectionMode="range"
        [readonlyInput]="true" dateFormat="dd/mm/yy"
        placeholder="Du … au …" appendTo="body"
        [showButtonBar]="true" (onSelect)="load()" (onClearClick)="load()"
        [style]="{ minWidth:'200px' }">
      </p-calendar>
    </div>

    <button *ngIf="hasActiveFilters" pButton type="button"
      icon="pi pi-times" label="Effacer les filtres"
      class="p-button-sm p-button-text p-button-secondary"
      (click)="clearFilters()">
    </button>
  </div>

  <!-- ─── Barre d'actions unifiée ─────────────────── -->
  <div class="action-bar">
    <span class="bulk-count" [class.has-selection]="selected.length">
      <i class="pi pi-check-square"></i>
      {{ selected.length }} sélectionné(s)
    </span>
    <button *ngIf="selected.length" pButton type="button" icon="pi pi-times" label="Désélectionner"
      class="p-button-sm p-button-text" (click)="selected = []; selectedAction = null">
    </button>
    <span class="bulk-sep"></span>

    <p-dropdown [options]="actionOptions" [(ngModel)]="selectedAction"
      optionLabel="label" optionValue="value"
      placeholder="Choisir une action…" [showClear]="true"
      appendTo="body" [style]="{ minWidth:'240px' }">
      <ng-template let-opt pTemplate="item">
        <span><i [class]="opt.icon" style="margin-right:.5rem"></i>{{ opt.label }}</span>
      </ng-template>
    </p-dropdown>

    <!-- Sous-champ : statut lead -->
    <p-dropdown *ngIf="selectedAction === 'statut'"
      [options]="statutLeadOptions" [(ngModel)]="bulkStatut"
      placeholder="Nouveau statut…"
      appendTo="body" [style]="{ minWidth:'200px' }">
    </p-dropdown>

    <!-- Sous-champ : conseiller -->
    <p-dropdown *ngIf="selectedAction === 'assign'"
      [options]="usersFilter" [(ngModel)]="selectedAssignUserId"
      optionLabel="label" optionValue="value"
      [filter]="true" filterBy="label"
      placeholder="Conseiller cible…"
      appendTo="body" [style]="{ minWidth:'200px' }">
    </p-dropdown>

    <button pButton type="button" label="Exécuter" icon="pi pi-play"
      class="p-button-sm"
      [disabled]="!canExecuteAction()"
      [loading]="bulkBusy || exportingExcel"
      (click)="executeAction()">
    </button>

    <span *ngIf="selectedAction && actionNeedsSelection(selectedAction) && !selected.length"
      class="action-hint">
      <i class="pi pi-info-circle"></i> Sélectionnez au moins une ligne
    </span>
  </div>

  <!-- ─── Spinner ──────────────────────────────────── -->
  <div *ngIf="loading" class="spinner-wrap">
    <p-progressSpinner [style]="{width:'48px',height:'48px'}"></p-progressSpinner>
  </div>

  <!-- ─── Tableau ──────────────────────────────────── -->
  <div class="table-card" *ngIf="!loading">
    <p-table
      [value]="filteredContacts"
      [(selection)]="selected"
      dataKey="id"
      [paginator]="true"
      [rows]="15"
      [rowsPerPageOptions]="[15, 25, 50, 100]"
      styleClass="p-datatable-sm p-datatable-gridlines"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width:3rem"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
          <th style="min-width:210px">Contact</th>
          <th style="min-width:185px">Coordonnées</th>
          <th style="min-width:160px">Profil</th>
          <th style="min-width:120px">Propriétaire</th>
          <th style="min-width:100px">Créé le</th>
          <th style="min-width:170px">Statut lead</th>
          <th style="min-width:140px">Type</th>
          <th style="width:200px; text-align:center">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-c>
        <tr>
          <!-- Case à cocher -->
          <td><p-tableCheckbox [value]="c"></p-tableCheckbox></td>

          <!-- Nom + ref + badges -->
          <td>
            <div class="name-cell">
              <div class="contact-avatar" [style.background]="avatarColor(c)">{{ initials(c) }}</div>
              <div class="name-cell-info">
                <div class="contact-name">
                  <span *ngIf="c.civilite" class="civ">{{ c.civilite }}</span>{{ fullName(c) }}
                </div>
                <div class="contact-ref">{{ c.reference || ('#' + c.id) }}</div>
                <div class="contact-badges">
                  <span *ngIf="c.est_assure2" class="mini-badge couple">
                    <i class="pi pi-users"></i> Conjoint
                  </span>
                </div>
              </div>
            </div>
          </td>

          <!-- Coordonnées -->
          <td>
            <div class="contact-coords">
              <span *ngIf="c.mobile"><i class="pi pi-mobile"></i>{{ c.mobile }}</span>
              <span *ngIf="c.fixe"><i class="pi pi-phone"></i>{{ c.fixe }}</span>
              <span *ngIf="c.email" class="email-line" [class.email-invalid]="c.email_is_valid === false">
                <i class="pi" [class.pi-envelope]="c.email_is_valid !== false" [class.pi-times-circle]="c.email_is_valid === false"></i>{{ c.email }}
              </span>
              <span *ngIf="!c.mobile && !c.fixe && !c.email" style="color:#cbd5e1">—</span>
            </div>
          </td>

          <!-- Profil -->
          <td>
            <div class="profil-cell">
              <div *ngIf="age(c.date_naissance) != null" class="profil-age">
                <i class="pi pi-calendar"></i>{{ age(c.date_naissance) }} ans
              </div>
              <div *ngIf="c.ville" class="profil-job">
                <i class="pi pi-map-marker" style="font-size:.65rem;color:#94a3b8;margin-right:.2rem"></i>{{ c.ville }}<span *ngIf="c.code_postal"> ({{ c.code_postal }})</span>
              </div>
              <div *ngIf="c.profession_exacte" class="profil-job" [pTooltip]="c.profession_exacte">
                {{ c.profession_exacte }}
              </div>
              <div *ngIf="c.origine_du_lead" class="profil-origin">
                <i class="pi pi-flag"></i>{{ c.origine_du_lead }}
              </div>
              <span *ngIf="age(c.date_naissance) == null && !c.ville && !c.profession_exacte && !c.origine_du_lead"
                style="color:#cbd5e1">—</span>
            </div>
          </td>

          <!-- Propriétaire -->
          <td>
            <div class="owner-cell">
              <i class="pi pi-user"></i>{{ ownerLabel(c) }}
            </div>
          </td>

          <!-- Créé le -->
          <td style="font-size:.82rem;color:#64748b;white-space:nowrap">
            {{ c.created_at ? (c.created_at | date:'dd/MM/yyyy') : '—' }}
          </td>

          <!-- Statut lead inline -->
          <td>
            <p-dropdown
              [options]="statutLeadOptions"
              [(ngModel)]="c.statut_du_lead"
              (onChange)="updateField(c, 'statut_du_lead', $event.value)"
              [showClear]="true" placeholder="—"
              appendTo="body" [style]="{ minWidth:'160px' }">
            </p-dropdown>
          </td>

          <!-- Type contact inline -->
          <td>
            <p-dropdown
              [options]="typeContactOptions"
              [(ngModel)]="c.type_contact"
              (onChange)="updateField(c, 'type_contact', $event.value)"
              [showClear]="true" placeholder="—"
              appendTo="body" [style]="{ minWidth:'135px' }">
            </p-dropdown>
          </td>

          <!-- Actions -->
          <td>
            <div class="row-actions">
              <button pButton type="button" icon="pi pi-phone"
                class="p-button-rounded p-button-text p-button-sm btn-call"
                pTooltip="Appeler" tooltipPosition="top"
                [disabled]="!c.mobile && !c.fixe"
                (click)="callContact(c)">
              </button>
              <button pButton type="button" icon="pi pi-comment"
                class="p-button-rounded p-button-text p-button-sm btn-sms"
                pTooltip="SMS" tooltipPosition="top"
                [disabled]="!c.mobile"
                (click)="smsContact(c)">
              </button>
              <button pButton type="button" icon="pi pi-eye"
                class="p-button-rounded p-button-text p-button-sm"
                pTooltip="Détails" tooltipPosition="top"
                (click)="openDetails(c)">
              </button>
              <button pButton type="button" icon="pi pi-folder-open"
                class="p-button-rounded p-button-text p-button-sm btn-form"
                pTooltip="Ouvrir le formulaire" tooltipPosition="top"
                [disabled]="openingForm"
                (click)="openInForm(c)">
              </button>
              <button pButton type="button" icon="pi pi-list"
                class="p-button-rounded p-button-text p-button-sm btn-trans"
                pTooltip="Voir les transactions" tooltipPosition="top"
                (click)="viewTransactions(c)">
              </button>
              <button pButton type="button" icon="pi pi-trash"
                class="p-button-rounded p-button-text p-button-sm p-button-danger"
                pTooltip="Supprimer" tooltipPosition="top"
                (click)="deleteOne(c)">
              </button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="empty">
            <i class="pi pi-inbox"></i>
            Aucun contact trouvé.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

</div>

<!-- ─── Dialog Détails (fiche contact + transactions) ──── -->
<p-dialog
  header="Fiche contact & transactions"
  [(visible)]="detailVisible"
  [modal]="true"
  [style]="{ width:'1180px', maxWidth:'97vw' }"
  [dismissableMask]="true"
>
  <div *ngIf="selectedContact as c" class="split-view">

    <!-- ░░░ Colonne gauche : fiche contact ░░░ -->
    <div class="split-col contact-col details">
      <div class="col-head contact-head">
        <div class="contact-avatar lg" [style.background]="avatarColor(c)">{{ initials(c) }}</div>
        <div>
          <div class="col-head-title">{{ fullName(c) }}</div>
          <div class="col-head-sub">{{ c.reference || ('#' + c.id) }}</div>
        </div>
      </div>

      <!-- Actions rapides -->
      <div class="quick-actions">
        <button pButton type="button" icon="pi pi-phone" label="Appeler"
          class="p-button-sm p-button-outlined" style="color:#16a34a;border-color:#16a34a"
          [disabled]="!c.mobile && !c.fixe" (click)="callContact(c)"></button>
        <button pButton type="button" icon="pi pi-comment" label="SMS"
          class="p-button-sm p-button-outlined" style="color:#0891b2;border-color:#0891b2"
          [disabled]="!c.mobile" (click)="smsContact(c)"></button>
        <button pButton type="button" icon="pi pi-folder-open" label="Ouvrir le formulaire"
          class="p-button-sm p-button-outlined" style="color:#7c3aed;border-color:#7c3aed"
          [disabled]="openingForm" (click)="openInForm(c)"></button>
      </div>

      <h4>Assuré 1</h4>
      <div class="grid">
        <div><label>Type personne</label><span>{{ c.type_personne || '—' }}</span></div>
        <div><label>Civilité</label><span>{{ c.civilite || '—' }}</span></div>
        <div><label>Nom</label><span>{{ c.nom || '—' }}</span></div>
        <div><label>Prénom</label><span>{{ c.prenom || '—' }}</span></div>
        <div><label>Date naissance</label><span>{{ c.date_naissance ? (c.date_naissance | date:'dd/MM/yyyy') : '—' }}</span></div>
        <div><label>État civil</label><span>{{ c.etat_civil || '—' }}</span></div>
        <div><label>Mobile</label><span>{{ c.mobile || '—' }}</span></div>
        <div><label>Fixe</label><span>{{ c.fixe || '—' }}</span></div>
        <div><label>Email</label><span>{{ c.email || '—' }}</span></div>
        <div><label>Adresse</label><span>{{ c.adresse || '—' }}</span></div>
        <div><label>Complément</label><span>{{ c.complement_adresse || '—' }}</span></div>
        <div><label>Ville</label><span>{{ c.ville || '—' }}</span></div>
        <div><label>Code postal</label><span>{{ c.code_postal || '—' }}</span></div>
        <div><label>Pays</label><span>{{ c.pays || '—' }}</span></div>
        <div><label>Entreprise</label><span>{{ c.entreprise || '—' }}</span></div>
        <div><label>Profession</label><span>{{ c.profession_exacte || '—' }}</span></div>
        <div><label>Statut socio-pro</label><span>{{ c.statut_socioprofessionnel || '—' }}</span></div>
        <div><label>Site web</label><span>{{ c.site_web || '—' }}</span></div>
        <div><label>LinkedIn</label><span>{{ c.linkedin || '—' }}</span></div>
        <div><label>Origine du lead</label><span>{{ c.origine_du_lead || '—' }}</span></div>
        <div><label>Origine secondaire</label><span>{{ c.origine_secondaire_du_lead || '—' }}</span></div>
        <div><label>Statut lead</label><span>{{ c.statut_du_lead || '—' }}</span></div>
        <div><label>Type contact</label><span>{{ c.type_contact || '—' }}</span></div>
        <div><label>Cycle de vie</label><span>{{ c.cycle_de_vie || '—' }}</span></div>
        <div><label>État civil</label><span>{{ c.etat_civil || '—' }}</span></div>
        <div><label>Fumeur</label><span>{{ c.fumeur ? 'Oui' : 'Non' }}</span></div>
        <div><label>Avis client</label><span>{{ c.avis_client ? 'Oui' : 'Non' }}</span></div>
        <div><label>Propriétaire</label><span>{{ ownerLabel(c) }}</span></div>
      </div>

      <ng-container *ngIf="c.est_assure2">
        <h4>Assuré 2</h4>
        <div class="grid">
          <div><label>Civilité</label><span>{{ c.assure2_civilite || '—' }}</span></div>
          <div><label>Nom</label><span>{{ c.assure2_nom || '—' }}</span></div>
          <div><label>Prénom</label><span>{{ c.assure2_prenom || '—' }}</span></div>
          <div><label>Date naissance</label><span>{{ c.assure2_date_naissance ? (c.assure2_date_naissance | date:'dd/MM/yyyy') : '—' }}</span></div>
          <div><label>État civil</label><span>{{ c.assure2_etat_civil || '—' }}</span></div>
          <div><label>Mobile</label><span>{{ c.assure2_mobile || '—' }}</span></div>
          <div><label>Fixe</label><span>{{ c.assure2_fixe || '—' }}</span></div>
          <div><label>Email</label><span>{{ c.assure2_email || '—' }}</span></div>
          <div><label>Adresse</label><span>{{ c.assure2_adresse || '—' }}</span></div>
          <div><label>Complément</label><span>{{ c.assure2_complement_adresse || '—' }}</span></div>
          <div><label>Ville</label><span>{{ c.assure2_ville || '—' }}</span></div>
          <div><label>Code postal</label><span>{{ c.assure2_code_postal || '—' }}</span></div>
          <div><label>Pays</label><span>{{ c.assure2_pays || '—' }}</span></div>
          <div><label>Entreprise</label><span>{{ c.assure2_entreprise || '—' }}</span></div>
          <div><label>Profession</label><span>{{ c.assure2_profession_exacte || '—' }}</span></div>
          <div><label>Statut socio-pro</label><span>{{ c.assure2_statut_socioprofessionnel || '—' }}</span></div>
          <div><label>Type contact</label><span>{{ c.assure2_type_contact || '—' }}</span></div>
          <div><label>Site web</label><span>{{ c.assure2_site_web || '—' }}</span></div>
          <div><label>LinkedIn</label><span>{{ c.assure2_linkedin || '—' }}</span></div>
          <div><label>Fumeur</label><span>{{ c.assure2_fumeur ? 'Oui' : 'Non' }}</span></div>
        </div>
      </ng-container>
    </div>

    <!-- ░░░ Colonne droite : transactions du contact ░░░ -->
    <div class="split-col trans-col">
      <div class="col-head trans-head">
        <div class="title-icon sm"><i class="pi pi-briefcase"></i></div>
        <div>
          <div class="col-head-title">Transactions &amp; devis</div>
          <div class="col-head-sub">{{ contactTransactions.length }} liée(s) à ce contact</div>
        </div>
      </div>

      <div *ngIf="loadingTransactions" class="mini-spinner">
        <p-progressSpinner [style]="{width:'34px',height:'34px'}"></p-progressSpinner>
      </div>

      <div *ngIf="!loadingTransactions && !contactTransactions.length" class="mini-empty">
        <i class="pi pi-inbox"></i>
        Aucune transaction pour ce contact.
      </div>

      <div *ngIf="!loadingTransactions && contactTransactions.length" class="devis-list">
        <div *ngFor="let t of contactTransactions" class="devis-item"
          [class.devis-item--sent]="t.devis_envoye || t.numero_devis || t.nom_assureurs"
          [class.devis-item--signed]="t.statut_contrat === 'En cours' || t.numero_contrat">

          <!-- En-tête carte -->
          <div class="devis-item-top">
            <div class="devis-item-ref">
              <span class="trans-ref">{{ t.reference || t.project_id }}</span>
              <p-tag [value]="t.phase_transaction || '—'"
                [severity]="phaseSeverity(t.phase_transaction)"
                [style]="{ fontSize:'.62rem', padding:'.1rem .45rem' }">
              </p-tag>
            </div>
            <span *ngIf="t.date_envoi_devis" class="devis-date">
              <i class="pi pi-calendar"></i>{{ t.date_envoi_devis | date:'dd/MM/yyyy' }}
            </span>
          </div>

          <!-- Infos prêt -->
          <div class="devis-item-body">
            <div *ngIf="t.nb_enfant_assure != null"><label>Enfants assurés</label><span>{{ t.nb_enfant_assure }}</span></div>
            <div *ngIf="t.deplacement_professionnel"><label>Déplacement pro</label><span>Oui</span></div>
          </div>

          <!-- Statut devis -->
          <div class="devis-status-row">
            <span class="devis-badge" [class.sent]="hasDevis(t)">
              <i class="pi" [class.pi-check-circle]="hasDevis(t)"
                            [class.pi-clock]="!hasDevis(t)"></i>
              {{ hasDevis(t) ? 'Devis envoyé' : 'Pas encore envoyé' }}
            </span>
            <span *ngIf="t.nbre_devis_envoyes" class="devis-count">
              {{ t.nbre_devis_envoyes }} envoyé(s)
            </span>
            <span *ngIf="t.statut_contrat" class="devis-contrat-badge"
              [class.ok]="t.statut_contrat === 'En cours'">
              <i class="pi pi-file-check"></i> {{ t.statut_contrat }}
            </span>
          </div>

          <!-- Cartes individuelles par devis (JSON) -->
          <ng-container *ngIf="parseDevisHistory(t) as history">
            <div *ngIf="history.length" class="devis-quotes-list">
              <div *ngFor="let d of history" class="devis-quote-card">
                <div class="dqc-top">
                  <span class="dqc-assureur">{{ d.assureur }}</span>
                  <span class="dqc-date">{{ d.date | date:'dd/MM/yyyy' }}</span>
                </div>
                <div class="dqc-body">
                  <div *ngIf="d.montant_mensuel">
                    <label>Mensuel</label>
                    <span class="dqc-price">{{ d.montant_mensuel | number:'1.0-2' }} €</span>
                  </div>
                  <div *ngIf="d.montant_total">
                    <label>Total</label>
                    <span>{{ d.montant_total | number:'1.0-2' }} €</span>
                  </div>
                  <div *ngIf="d.label">
                    <label>Produit</label>
                    <span>{{ d.label }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Fallback texte si pas encore JSON -->
            <div *ngIf="!history.length && t.nom_assureurs" class="devis-item-body">
              <div><label>Assureurs</label><span>{{ t.nom_assureurs }}</span></div>
              <div *ngIf="t.cout_mensuel_assurance != null">
                <label>Mensuel</label>
                <span class="devis-price">{{ t.cout_mensuel_assurance | number:'1.0-2' }} €</span>
              </div>
            </div>
          </ng-container>

          <!-- Contrat souscrit -->
          <div class="devis-item-body" *ngIf="t.assureur || t.numero_contrat || t.motif_refus">
            <div *ngIf="t.assureur"><label>Souscrit</label><span>{{ t.assureur }}</span></div>
            <div *ngIf="t.numero_contrat"><label>N° contrat</label><span>{{ t.numero_contrat }}</span></div>
            <div *ngIf="t.motif_refus"><label>Motif refus</label><span class="text-danger">{{ t.motif_refus }}</span></div>
          </div>

          <div class="trans-item-foot">
            <button pButton type="button" icon="pi pi-folder-open" label="Ouvrir"
              class="p-button-sm p-button-text" style="color:#7c3aed"
              [disabled]="openingForm"
              (click)="loadTransactionForm(t)">
            </button>
          </div>
        </div>
      </div>

      <!-- ── Historique SMS Ringover ── -->
      <div class="right-section-head">
        <i class="pi pi-comments"></i>
        SMS Ringover
        <p-progressSpinner *ngIf="loadingSmsHistory"
          [style]="{width:'14px',height:'14px',marginLeft:'.4rem'}">
        </p-progressSpinner>
        <span *ngIf="!loadingSmsHistory && smsHistory.length" class="right-section-badge">
          {{ smsHistory.length }}
        </span>
      </div>

      <div *ngIf="smsHistoryError" class="sms-hist-unavail">
        <i class="pi pi-exclamation-triangle"></i>
        Permission <strong>Conversations Read</strong> manquante sur la clé API Ringover.
        Activez-la dans Dashboard → Developer → Edit clé.
      </div>

      <div *ngIf="!loadingSmsHistory && !smsHistoryError && smsHistory.length === 0" class="mini-empty" style="padding:1rem 0">
        <i class="pi pi-comments"></i>
        Aucun SMS trouvé.
      </div>

      <div *ngIf="!loadingSmsHistory && smsHistory.length" class="sms-hist-list">
        <div *ngFor="let s of smsHistory" class="sms-hist-item"
          [class.sms-out]="s.direction === 'OUT'">
          <div class="sms-hist-meta">
            <span class="sms-dir">{{ s.direction === 'OUT' ? '↑ Envoyé' : '↓ Reçu' }}</span>
            <span class="sms-dt">{{ s.date | date:'dd/MM/yyyy HH:mm' }}</span>
            <span *ngIf="s.is_failed" class="sms-failed">✗ échec</span>
          </div>
          <div class="sms-hist-text">{{ s.content || '(vide)' }}</div>
        </div>
      </div>

    </div>

  </div>
</p-dialog>

<!-- ─── Dialog sélection de la transaction à ouvrir ────── -->
<p-dialog
  header="Choisir la transaction à ouvrir"
  [(visible)]="formSelectVisible"
  [modal]="true"
  [style]="{ width:'560px', maxWidth:'95vw' }"
  [dismissableMask]="true"
>
  <p class="select-hint" *ngIf="formSelectContact as c">
    <i class="pi pi-info-circle"></i>
    {{ fullName(c) }} possède {{ formSelectTransactions.length }} transactions. Sélectionnez celle à charger dans le formulaire.
  </p>
  <div class="select-list">
    <button *ngFor="let t of formSelectTransactions" type="button" class="select-row"
      (click)="loadTransactionForm(t)">
      <div class="select-row-main">
        <span class="trans-ref">{{ t.reference || t.project_id }}</span>
        <p-tag [value]="t.phase_transaction || '—'" [severity]="phaseSeverity(t.phase_transaction)"
          [style]="{ fontSize:'.66rem' }"></p-tag>
      </div>
        <div class="select-row-sub">
          <span *ngIf="t.nb_enfant_assure != null">Enfants: {{ t.nb_enfant_assure }}</span>
        </div>
      <i class="pi pi-folder-open select-row-icon"></i>
    </button>
  </div>
</p-dialog>

<!-- ─── Dialog Nouveau contact ───────────────────────── -->
<p-dialog
  header="Nouveau contact"
  [(visible)]="createVisible"
  [modal]="true"
  [style]="{ width:'860px', maxWidth:'97vw' }"
  [contentStyle]="{ maxHeight:'78vh', overflowY:'auto' }"
  [dismissableMask]="true"
>
  <div class="create-form">

    <!-- ══ Assuré 1 ══ -->
    <div class="create-section">Identité Assuré 1</div>
    <div class="create-grid">
      <div class="create-field">
        <label>Type personne</label>
        <p-dropdown [options]="typePersonneOptions" [(ngModel)]="newContact.type_personne"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }"></p-dropdown>
      </div>
      <div class="create-field">
        <label>Civilité</label>
        <p-dropdown [options]="civiliteOptions" [(ngModel)]="newContact.civilite"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }"></p-dropdown>
      </div>
      <div class="create-field">
        <label>Prénom</label>
        <input pInputText [(ngModel)]="newContact.prenom" placeholder="Prénom" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Nom <span class="req">*</span></label>
        <input pInputText [(ngModel)]="newContact.nom" placeholder="Nom" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Date de naissance</label>
        <input pInputText type="date" [(ngModel)]="newContact.date_naissance" style="width:100%" />
      </div>
      <div class="create-field">
        <label>État civil</label>
        <p-dropdown [options]="etatCivilOptions" [(ngModel)]="newContact.etat_civil"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }"></p-dropdown>
      </div>
      <div class="create-field">
        <label>Fumeur</label>
        <p-dropdown [options]="ouiNonOptions" [(ngModel)]="newContact.fumeur"
          optionLabel="label" optionValue="value"
          appendTo="body" [style]="{ width:'100%' }"></p-dropdown>
      </div>
    </div>

    <div class="create-section">Coordonnées Assuré 1</div>
    <div class="create-grid">
      <div class="create-field">
        <label>Mobile</label>
        <input pInputText [(ngModel)]="newContact.mobile" placeholder="06 …" style="width:100%" />
        <button *ngIf="newContact.mobile" pButton type="button" icon="pi pi-phone" label="Appeler"
          class="p-button-sm p-button-outlined" style="color:#16a34a;border-color:#16a34a;margin-top:6px"
          (click)="callPhone(newContact.mobile)"></button>
      </div>
      <div class="create-field">
        <label>Fixe</label>
        <input pInputText [(ngModel)]="newContact.fixe" placeholder="01 …" style="width:100%" />
        <button *ngIf="newContact.fixe" pButton type="button" icon="pi pi-phone" label="Appeler"
          class="p-button-sm p-button-outlined" style="color:#16a34a;border-color:#16a34a;margin-top:6px"
          (click)="callPhone(newContact.fixe)"></button>
      </div>
      <div class="create-field cf-wide">
        <label>Email</label>
        <input pInputText type="email" [(ngModel)]="newContact.email" placeholder="prenom.nom@…" style="width:100%" />
      </div>
      <div class="create-field cf-wide">
        <label>Adresse</label>
        <input pInputText [(ngModel)]="newContact.adresse" placeholder="Numéro et rue" style="width:100%" />
      </div>
      <div class="create-field cf-wide">
        <label>Complément adresse</label>
        <input pInputText [(ngModel)]="newContact.complement_adresse" placeholder="Bât, étage…" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Ville</label>
        <input pInputText [(ngModel)]="newContact.ville" placeholder="Ville" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Code postal</label>
        <input pInputText [(ngModel)]="newContact.code_postal" placeholder="75000" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Pays</label>
        <input pInputText [(ngModel)]="newContact.pays" placeholder="France" style="width:100%" />
      </div>
    </div>

    <div class="create-section">CRM</div>
    <div class="create-grid">
      <div class="create-field">
        <label>Origine du lead</label>
        <p-dropdown [options]="origine_du_leadOptions" [(ngModel)]="newContact.origine_du_lead"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }"></p-dropdown>
      </div>
      <div class="create-field">
        <label>Origine secondaire</label>
        <input pInputText [(ngModel)]="newContact.origine_secondaire_du_lead" placeholder="—" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Statut lead</label>
        <p-dropdown [options]="statutLeadOptions" [(ngModel)]="newContact.statut_du_lead"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }"></p-dropdown>
      </div>
      <div class="create-field">
        <label>Type contact</label>
        <p-dropdown [options]="typeContactOptions" [(ngModel)]="newContact.type_contact"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }"></p-dropdown>
      </div>
      <div class="create-field">
        <label>Cycle de vie</label>
        <p-dropdown [options]="cycleDeVieOptions" [(ngModel)]="newContact.cycle_de_vie"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }"></p-dropdown>
      </div>
      <div class="create-field">
        <label>Avis client</label>
        <p-dropdown [options]="ouiNonOptions" [(ngModel)]="newContact.avis_client"
          optionLabel="label" optionValue="value"
          appendTo="body" [style]="{ width:'100%' }"></p-dropdown>
      </div>
    </div>

    <div class="create-section">Professionnel Assuré 1</div>
    <div class="create-grid">
      <div class="create-field cf-wide">
        <label>Statut socio-professionnel</label>
        <p-dropdown [options]="professionalCategoryOptions" [(ngModel)]="newContact.statut_socioprofessionnel"
          optionLabel="label" optionValue="value"
          [filter]="true" filterBy="label"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }"></p-dropdown>
      </div>
      <div class="create-field">
        <label>Profession exacte</label>
        <input pInputText [(ngModel)]="newContact.profession_exacte" placeholder="Profession" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Entreprise</label>
        <input pInputText [(ngModel)]="newContact.entreprise" placeholder="Entreprise" style="width:100%" />
      </div>
      <div class="create-field cf-wide">
        <label>Site web</label>
        <input pInputText [(ngModel)]="newContact.site_web" placeholder="https://…" style="width:100%" />
      </div>
      <div class="create-field cf-wide">
        <label>LinkedIn</label>
        <input pInputText [(ngModel)]="newContact.linkedin" placeholder="https://linkedin.com/in/…" style="width:100%" />
      </div>
    </div>

    <!-- ══ Assuré 2 toggle ══ -->
    <div class="create-section assure2-toggle">
      Assuré 2 (Conjoint)
      <p-dropdown [options]="ouiNonOptions" [(ngModel)]="newContact.est_assure2"
        optionLabel="label" optionValue="value"
        appendTo="body" [style]="{ minWidth:'100px', marginLeft:'.75rem' }">
      </p-dropdown>
    </div>

    <ng-container *ngIf="newContact.est_assure2">
      <div class="create-section sub">Identité Assuré 2</div>
      <div class="create-grid">
        <div class="create-field">
          <label>Civilité</label>
          <p-dropdown [options]="civiliteOptions" [(ngModel)]="newContact.assure2_civilite"
            [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }"></p-dropdown>
        </div>
        <div class="create-field">
          <label>Prénom</label>
          <input pInputText [(ngModel)]="newContact.assure2_prenom" placeholder="Prénom" style="width:100%" />
        </div>
        <div class="create-field">
          <label>Nom</label>
          <input pInputText [(ngModel)]="newContact.assure2_nom" placeholder="Nom" style="width:100%" />
        </div>
        <div class="create-field">
          <label>Date de naissance</label>
          <input pInputText type="date" [(ngModel)]="newContact.assure2_date_naissance" style="width:100%" />
        </div>
        <div class="create-field">
          <label>État civil</label>
          <p-dropdown [options]="etatCivilOptions" [(ngModel)]="newContact.assure2_etat_civil"
            [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }"></p-dropdown>
        </div>
        <div class="create-field">
          <label>Fumeur</label>
          <p-dropdown [options]="ouiNonOptions" [(ngModel)]="newContact.assure2_fumeur"
            optionLabel="label" optionValue="value"
            appendTo="body" [style]="{ width:'100%' }"></p-dropdown>
        </div>
      </div>

      <div class="create-section sub">Coordonnées Assuré 2</div>
      <div class="create-grid">
        <div class="create-field">
          <label>Mobile</label>
          <input pInputText [(ngModel)]="newContact.assure2_mobile" placeholder="06 …" style="width:100%" />
          <button *ngIf="newContact.assure2_mobile" pButton type="button" icon="pi pi-phone" label="Appeler"
            class="p-button-sm p-button-outlined" style="color:#16a34a;border-color:#16a34a;margin-top:6px"
            (click)="callPhone(newContact.assure2_mobile)"></button>
        </div>
        <div class="create-field">
          <label>Fixe</label>
          <input pInputText [(ngModel)]="newContact.assure2_fixe" placeholder="01 …" style="width:100%" />
          <button *ngIf="newContact.assure2_fixe" pButton type="button" icon="pi pi-phone" label="Appeler"
            class="p-button-sm p-button-outlined" style="color:#16a34a;border-color:#16a34a;margin-top:6px"
            (click)="callPhone(newContact.assure2_fixe)"></button>
        </div>
        <div class="create-field cf-wide">
          <label>Email</label>
          <input pInputText type="email" [(ngModel)]="newContact.assure2_email" placeholder="…" style="width:100%" />
        </div>
        <div class="create-field cf-wide">
          <label>Adresse</label>
          <input pInputText [(ngModel)]="newContact.assure2_adresse" placeholder="Numéro et rue" style="width:100%" />
        </div>
        <div class="create-field cf-wide">
          <label>Complément adresse</label>
          <input pInputText [(ngModel)]="newContact.assure2_complement_adresse" placeholder="Bât, étage…" style="width:100%" />
        </div>
        <div class="create-field">
          <label>Ville</label>
          <input pInputText [(ngModel)]="newContact.assure2_ville" placeholder="Ville" style="width:100%" />
        </div>
        <div class="create-field">
          <label>Code postal</label>
          <input pInputText [(ngModel)]="newContact.assure2_code_postal" placeholder="75000" style="width:100%" />
        </div>
        <div class="create-field">
          <label>Pays</label>
          <input pInputText [(ngModel)]="newContact.assure2_pays" placeholder="France" style="width:100%" />
        </div>
      </div>

      <div class="create-section sub">Professionnel Assuré 2</div>
      <div class="create-grid">
        <div class="create-field cf-wide">
          <label>Statut socio-professionnel</label>
          <p-dropdown [options]="professionalCategoryOptions" [(ngModel)]="newContact.assure2_statut_socioprofessionnel"
            optionLabel="label" optionValue="value"
            [filter]="true" filterBy="label"
            [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }"></p-dropdown>
        </div>
        <div class="create-field">
          <label>Type contact</label>
          <p-dropdown [options]="typeContactOptions" [(ngModel)]="newContact.assure2_type_contact"
            [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }"></p-dropdown>
        </div>
        <div class="create-field">
          <label>Profession exacte</label>
          <input pInputText [(ngModel)]="newContact.assure2_profession_exacte" placeholder="Profession" style="width:100%" />
        </div>
        <div class="create-field">
          <label>Entreprise</label>
          <input pInputText [(ngModel)]="newContact.assure2_entreprise" placeholder="Entreprise" style="width:100%" />
        </div>
        <div class="create-field cf-wide">
          <label>Site web</label>
          <input pInputText [(ngModel)]="newContact.assure2_site_web" placeholder="https://…" style="width:100%" />
        </div>
        <div class="create-field cf-wide">
          <label>LinkedIn</label>
          <input pInputText [(ngModel)]="newContact.assure2_linkedin" placeholder="https://linkedin.com/in/…" style="width:100%" />
        </div>
      </div>
    </ng-container>

  </div>

  <ng-template pTemplate="footer">
    <div style="display: flex; justify-content: space-between; width: 100%;">
      <button pButton type="button" label="Remplir (Test)" icon="pi pi-bolt"
        class="p-button-text p-button-info p-button-sm" (click)="fillExampleData()">
      </button>
      <div>
        <button pButton type="button" label="Annuler" icon="pi pi-times"
          class="p-button-text p-button-secondary" (click)="createVisible = false">
        </button>
        <button pButton type="button" label="Créer le contact" icon="pi pi-check"
          class="p-button-sm btn-create" [disabled]="saving" (click)="saveContact()">
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<!-- ── SMS : relecture avant envoi (via Ringover) ── -->
<p-dialog
  header="Vérifier et envoyer le SMS"
  [(visible)]="smsDialogVisible"
  [modal]="true"
  [style]="{ width:'560px', maxWidth:'96vw' }"
  [dismissableMask]="true">
  <div *ngIf="smsDialogContact" style="display:flex;flex-direction:column;gap:10px">
    <div style="display:flex;align-items:center;gap:8px;color:#555">
      <i class="pi pi-mobile"></i>
      <div>
        <div style="font-weight:600">{{ fullName(smsDialogContact) }}</div>
        <div style="font-size:12px;color:#888">{{ smsDialogPhone }}</div>
      </div>
    </div>
    <div style="display:flex;align-items:center;justify-content:space-between;font-size:12px;color:#555">
      <span><i class="pi pi-pencil"></i> Message SMS</span>
      <span [style.color]="smsDialogContent.length > 800 ? '#d97706' : '#888'">
        {{ smsDialogContent.length }} caractères
      </span>
    </div>
    <textarea [(ngModel)]="smsDialogContent" rows="12"
      style="width:100%;box-sizing:border-box;resize:vertical;border:1px solid #cfd8dc;border-radius:8px;padding:8px;font:inherit"
      placeholder="Rédigez votre message…"></textarea>
    <div style="font-size:12px;color:#888">
      <i class="pi pi-info-circle"></i>
      Vous pouvez modifier le message avant de l'envoyer. L'envoi est effectué via Ringover.
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Annuler" icon="pi pi-times"
      class="p-button-text p-button-secondary"
      (click)="smsDialogVisible = false" [disabled]="smsDialogSending">
    </button>
    <button pButton type="button" label="Envoyer le SMS" icon="pi pi-send"
      class="p-button-sm" style="background:#0891b2;border-color:#0891b2"
      [disabled]="smsDialogSending || !smsDialogContent.trim()"
      [loading]="smsDialogSending"
      (click)="sendSmsFromDialog()">
    </button>
  </ng-template>
</p-dialog>
